import { createFileRoute } from '@tanstack/react-router';
import ComingSoonCover from '@/components/ComingSoonCover';
export const Route = createFileRoute('/_staff/contract/$id/_layout/_placeholders/approval-info')({
  component: RouteComponent
});
function RouteComponent() {
  return <ComingSoonCover />;
}